export default __webpack_public_path__ + "static/media/lambda-pt.e612f75d.gif";